var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dwgmain"},[_c('div',{ref:"dwgbox",attrs:{"id":"dwgbox"}}),(_vm.dwgloaded)?_c('application',{ref:"application",attrs:{"type":"dwg"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }